import * as services from '../services';

export default {
  namespace: 'dynamicModel',
  state: {
    // homeObj: {}, // 首页
  },

  reducers: {
    updateState(state: any, { res }: any) {
      // 更新state
      return {
        ...state,
        ...res,
      };
    },
  },

  effects: {
    // 获取数据
    *postData({ payload, mTitle, apiUrl }, { call, put, select }) {
      const result = yield call(services.postDataService, payload, apiUrl);
      if (result && mTitle) {
        yield put({ type: 'updateState', res: { [mTitle]: result.data } });
      }
      return result;
    },
    // 获取数据
    *getData({ payload, mTitle, apiUrl, contentType }, { call, put, select }) {
      const result = yield call(services.getDataService, payload, apiUrl, contentType);
      if (result && mTitle) {
        yield put({ type: 'updateState', res: { [mTitle]: result.data } });
      }
      return result;
    },
  },
};
